import { Boxes } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const InventoryResultsPage = lazyPage(() => import("./ResultsPage"), "InventoryResultsPage");
const InventoryResultPage = lazyPage(() => import("./ResultPage"), "InventoryResultPage");
const RecommendationsPage = lazyPage(() => import("./RecommendationsPage"), "RecommendationsPage");

export default defineModuleUi({
  key: "inventory",
  title: "Inventário de Sistemas",
  domain: "diagnostics",
  icon: Boxes,
  menu: [
    { path: "/diagnostico/inventario", label: "Inventário de sistemas", minRole: "member", icon: Boxes, order: 20, keywords: "sistemas senhas planilhas integração recomendação" },
  ],
  routes: [
    { path: "/diagnostico/inventario", element: <InventoryResultsPage />, minRole: "member" },
    { path: "/diagnostico/inventario/recomendacoes", element: <RecommendationsPage />, minRole: "member" },
    { path: "/diagnostico/inventario/:id", element: <InventoryResultPage />, minRole: "member" },
  ],
});
